import { SessionStore } from '../../constants/sessionStore';

/** Get Project Id from Session Storage */
export const getProjectId = (): number | undefined => {
  const workflowSession = sessionStorage.getItem(SessionStore.workflowSession);
  try {
    if (workflowSession) return JSON.parse(workflowSession).projectId;
  } catch (e) {
    console.error('Parse Error in fetching projectId: ', e);
  }
};
